import { HttpBackend, HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { ApiService } from '@core/api/api.service';
import { EnvConfig } from '@core/config';
import { Observable, of, tap } from "rxjs";
import { saveFile } from "@core/attachment/helpers";
import { catchError } from "rxjs/operators";

@Injectable({
  providedIn: 'root',
})
export class DownloaderService {
  private httpClient: HttpClient;

  constructor(private api: ApiService, private env: EnvConfig, handler: HttpBackend) {
    this.httpClient = new HttpClient(handler);
  }

  public download(url: string, external?: boolean): Observable<Blob> {
    // Clean up any origin + apiUrl from the url (as will be added later, inside the interceptor)
    const relativeUrl = url.split(`${this.env.apiUrl}/`).pop();

    if (external) {
      return this.httpClient.get(url, { responseType: 'blob' });
    }

    return this.api.get(relativeUrl, { responseType: 'blob' });
  }

  public downloadAndSave(url: string, filename: string): Observable<boolean> {
    return new Observable((observer) => {
      this.download(url)
        .pipe(
          tap((blob) => saveFile(blob, filename).subscribe((result) => {
            observer.next(result);
            observer.complete();
          })),
          catchError(() => {
            observer.next(false);
            observer.complete();
            return of(false);
          }),
        ).subscribe();
    });
  }
}
